import { Box } from "@chakra-ui/react";
import HeaderTable from "./HeaderTable";
import RowTable from "./RowTable";

export default function ProvisaoTable({
 items,
  saldoParcial
}: {
 items: {
    id: string;
    debito: number;
    credito: number;
    historico: string;
    valor: number;
    saldoParcial?:number;
  }[];
  saldoParcial?:boolean
}) {
  return (
    <Box>
      <HeaderTable saldoParcial={saldoParcial} />
      {items.map((item: any) => (
        <RowTable item={item} saldoParcial={saldoParcial} />
      ))}
    </Box>
  );
}
